




















































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Lot, Bid, ApiError, User } from '@/api';
import { snackModule } from '@/store';
import RelAutocompleteAsync from '@/components/RelAutocompleteAsync.vue';

@Component({
  components: { RelAutocompleteAsync },
})
export default class extends Vue {
  @Prop({ required: true }) readonly lot: Lot;
  @Prop({ required: false }) readonly selectedBid: Bid;

  valid: boolean = false;
  loading: boolean = false;

  bid: Bid | null = null;

  bidValue: number | null = null;
  bidUser: User | null = null;

  users: Array<{ text: string; value: User }> | null = null;
  loadingUsers: boolean = false;

  currencyRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',

    (v: string) =>
      v8n()
        .string()
        .currency()
        .test(v) || 'Bid value must be greater than 0',
  ];

  get modalTitle() {
    return this.selectedBid ? 'Edit Bid' : 'Add Bid';
  }

  close() {
    this.$emit('close-bid');
  }

  userScopeFactory() {
    return User.includes([]).order('email');
  }

  async save() {
    if (!this.bid || !this.bidValue || !this.bidUser) {
      return;
    }

    this.bid.lot = this.lot;
    this.bid.user = this.bidUser;

    // @ts-ignore
    this.bid.value = this.$parseCurrency(this.bidValue);

    try {
      await this.bid.save({ with: ['lot.id', 'user.id'] });
      if (this.selectedBid) {
        snackModule.showSnackbar('Bid Saved');
      } else {
        snackModule.showSnackbar('Bid Added');
      }
      this.$emit('update-bids');
      this.$emit('close-bid');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async beforeMount() {
    const currency = () => {
      // @ts-ignore
      return (value: string) => this.$parseCurrency(value) > 0;
    };
    v8n.extend({ currency });
  }

  async mounted() {
    if (this.selectedBid && this.selectedBid.id) {
      try {
        const scope = await Bid.includes(['user']).find(this.selectedBid.id);
        this.bid = scope.data;

        if (this.bid) {
          this.bidValue = this.bid.value;
          this.bidUser = this.bid.user;
        }
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Probably not found');
      }
    } else {
      this.bid = new Bid();
    }

    try {
      this.loadingUsers = true;
      const users = (await User.order('email').all()).data;
      this.users = users.map(user => {
        return Object.assign({}, { text: user.email, value: user });
      });
    } catch (err) {
      // Error
    } finally {
      this.loadingUsers = false;
    }
  }
}
